module.exports = __webpack_public_path__ + "img/webhook-guide.5c355a3d.png";